var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertFill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60474_78362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7217 2.49964L18.66 16.2496C18.7332 16.3763 18.7717 16.52 18.7717 16.6663C18.7717 16.8126 18.7332 16.9563 18.66 17.083C18.5869 17.2096 18.4817 17.3148 18.355 17.388C18.2283 17.4611 18.0846 17.4996 17.9384 17.4996H2.06171C1.91543 17.4996 1.77173 17.4611 1.64505 17.388C1.51837 17.3148 1.41317 17.2096 1.34003 17.083C1.2669 16.9563 1.22839 16.8126 1.22839 16.6663C1.22839 16.52 1.2669 16.3763 1.34004 16.2496L9.27837 2.49964C9.35151 2.37296 9.45671 2.26778 9.58339 2.19464C9.71007 2.12151 9.85376 2.08301 10 2.08301C10.1463 2.08301 10.29 2.12151 10.4167 2.19464C10.5434 2.26778 10.6486 2.37296 10.7217 2.49964ZM9.1667 13.333V14.9996H10.8334V13.333H9.1667ZM9.1667 7.49964V11.6663H10.8334V7.49964H9.1667Z",
    fill: "#EF4343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60474_78362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert-fill.svg";